<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<crucible-dialog
  [dialogTitle]="(data.injectType.id ? 'Edit' : 'Create') + ' Inject Type'"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (!!data && data.injectType !== undefined && data.injectType !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input
              type="text"
              title="The Name of the Inject Type"
              matInput
              placeholder="Name (required)"
              [(ngModel)]="data.injectType.name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <input
              type="text"
              title="The Description of the Inject Type"
              matInput
              placeholder="Description (required)"
              [(ngModel)]="data.injectType.description">
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
